import { render, staticRenderFns } from "./IconMoon.vue?vue&type=template&id=552b38c7&"
import script from "./IconMoon.vue?vue&type=script&lang=js&"
export * from "./IconMoon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('552b38c7')) {
      api.createRecord('552b38c7', component.options)
    } else {
      api.reload('552b38c7', component.options)
    }
    module.hot.accept("./IconMoon.vue?vue&type=template&id=552b38c7&", function () {
      api.rerender('552b38c7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconMoon.vue"
export default component.exports